// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useReportingMap } from 'sonata-platform-components';
import { BoxV2 } from 'sonata-react-components';

import { MapRankingPanel } from '@/ts-modules/reporting/Map/MapRankingPanel';
import { RankingBottomPanelStyle } from './rankingBottomPanel.style';

import type { Map as MapComponent } from 'sonata-platform-components/lib/types/types/reportingMap.types';

type Props = {
  isFootfallAttrMap?: boolean;
  rankingIsExpanded?: boolean;
};

export function RankingBottomPanel({ isFootfallAttrMap = false, rankingIsExpanded = false }: Props) {
  const { formatMessage } = useIntl();

  const {
    state: { maps }
  } = useReportingMap();

  return (
    <RankingBottomPanelStyle className="mapRankingBottomPanel">
      <BoxV2 className="mapRankingBottomPanel__box" id="mapRankingBottomPanel-box">
        <BoxV2.Header
          bgColor="background01"
          expandablePosition="right"
          expanded={rankingIsExpanded}
          isExpandable
          padding="12px 16px"
        >
          <BoxV2.Header.Title
            icon="fas fa-chart-bar"
            title={formatMessage({
              defaultMessage: 'Ranking by cartography',
              id: 'reporting.map.rankingRightPanel.title'
            })}
            titleFontStyles="bodySoft alignLeft fontRegular"
          />
        </BoxV2.Header>
        <BoxV2.Body bgColor="backgroundReportingMapPopup" className="mapRankingBottomPanel__boxBody" padding="0">
          <div className="mapRankingBottomPanel__rankings">
            {maps.map(({ id: mapId }: { id: MapComponent['id'] }) => (
              <div className="mapRankingBottomPanel__mapRanking" key={`mapRankingPanel__${mapId}`}>
                <MapRankingPanel filterSection="maps" isFootfallAttrMap={isFootfallAttrMap} mapId={mapId} />
              </div>
            ))}
          </div>
        </BoxV2.Body>
      </BoxV2>
    </RankingBottomPanelStyle>
  );
}
